// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"4f8f0cac","119":"079a9eb3","275":"3b97074a","307":"fcbeb30f","407":"a16ec67e","679":"56981b0c","777":"52626c37"}[chunkId] + ".chunk.css";
};